import script from "./RolesView.vue?vue&type=script&setup=true&lang=js"
export * from "./RolesView.vue?vue&type=script&setup=true&lang=js"

import "./RolesView.vue?vue&type=style&index=0&id=bd780954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd780954"]])

export default __exports__